<template>
  <dl class="topic">
    <!-- 头部 -->
    <dt class="topic-header">
      <div class="topic-header__left">
        <h1 class="topic-header__title">黄页类别</h1>
      </div>
      <div class="topic-header__right">
        <router-link to="/publish">
          <i class="yk-manger"></i>
          <span>我要发布黄页</span>
        </router-link>
      </div>
    </dt>

    <YorkbbsSkeleton class="topic-skeleton" :count="20" :loading="loading" v-if="loading">
      <div slot="template" class="topic-skeleton__item">
        <el-skeleton-item variant="image"></el-skeleton-item>
        <div class="topic-skeleton__right">
          <el-skeleton-item variant="text"></el-skeleton-item>
          <el-skeleton-item variant="text"></el-skeleton-item>
          <el-skeleton-item variant="text"></el-skeleton-item>
        </div>
      </div>
    </YorkbbsSkeleton>

    <!-- 板块列表 -->
    <dd class="topic-list__wrapper">
      <ul class="topic-list" v-for="(item, i) in list" :key="i">
        <li class="topic-item" v-for="(suptopic, j) in item" :key="`suptopic-${j}`">
          <YorkbbsImage class="topic-item__logo" :src="suptopic.logo | webpFormat(100)" animation></YorkbbsImage>
          <div class="topic-item__right">
            <h2>
              <template v-if="suptopic.businessType && suptopic.businessType.id > 1">
                <router-link class="topic-name" :style="{ color: suptopic.foreColor || '#111' }"
                  :to="`/${suptopic.businessType.name_en}list/${suptopic.englishName}`">{{ suptopic.name }}</router-link>
              </template>
              <template v-else>
                <router-link class="topic-name" :style="{ color: suptopic.foreColor || '#111' }"
                  :to="`/list/${suptopic.englishName}`">{{ suptopic.name }}</router-link>
              </template>
              
            </h2>
            <div class="subtopic-list">
              <template v-if="suptopic.businessType && suptopic.businessType.id > 1">
                <router-link class="subtopic-item" v-for="(subtopic, k) in suptopic.children" :key="`subtopic-${k}`"
                  :style="{ color: subtopic.foreColor || '#333' }"
                  :to="`/${suptopic.businessType.name_en}list/${subtopic.englishName}`">{{ subtopic.name
                  }}</router-link>
              </template>
              <template v-else>
                <router-link class="subtopic-item" v-for="(subtopic, k) in suptopic.children" :key="`subtopic-${k}`"
                  :style="{ color: subtopic.foreColor || '#333' }" :to="`/list/${subtopic.englishName}`">{{
                  subtopic.name }}</router-link>
              </template>

            </div>
          </div>
        </li>
      </ul>
    </dd>
  </dl>
</template>
<script>
import YorkbbsSkeleton from '@/common/skeleton.vue';
export default {
  name: 'Topics',
  components: { YorkbbsSkeleton },
  data() {
    return {
      // 板块加载状态
      loading: false,
      // 板块列表
      list: [],
    };
  },
  created() {
    this.getTopics();
  },
  methods: {
    /**
     * 获取版块列表
     */
    async getTopics() {
      this.loading = true;
      const { data } = await this.$axios
        .post('/info/v1/get/topic/tree', {
          status: [0],
          topicType: [1, 2],
        })
        .finally(() => {
          this.loading = false;
        });

      const num = 9;
      this.list = [data.topic.slice(0, num), data.topic.slice(num)];
      console.log('list', this.list);
    },
  },
};
</script>
<style lang="scss" scoped>
.topic {
  padding-top: 20px;
}

.topic-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px solid #f8f8f8;
  margin-bottom: 20px;
}

.topic-header__left {
  a {
    display: inline-block;
  }
}

.topic-header__right {
  a {
    display: inline-block;
    font-size: 14px;
    color: var(--primary-color);

    i {
      margin-right: 5px;
    }
  }

  &:hover {
    opacity: 0.8;
  }
}

.topic-header__title {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: var(--text-color-3);
  margin-right: 20px;
}

.topic-list__wrapper {
  display: flex;
}

.topic-list {
  width: 50%;
}

.topic-item {
  display: flex;
  margin-bottom: 20px;
  background-color: #fff;
}

.topic-item__logo {
  width: 80px;
  height: 62px;
  border-radius: 4px;
  border: 1px solid #f8f8f8;
}

.topic-item__right {
  flex: 1;
  padding-left: 20px;
}

.topic-name {
  display: inline-block;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  color: var(--text-color-3);
  margin-bottom: 10px;

  &:hover {
    color: var(--primary-color) !important;
  }
}

.subtopic-list {
  display: flex;
  flex-wrap: wrap;
}

.subtopic-item {
  width: 80px;
  font-size: 15px;
  line-height: 22px;
  margin-bottom: 7px;

  &:hover {
    color: var(--primary-color) !important;
  }
}

.topic-skeleton {
  ::v-deep {
    .el-skeleton {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }

    .topic-skeleton__item {
      display: flex;
      width: 49%;

      &:nth-child(n + 3) {
        margin-top: 20px;
      }
    }

    .topic-skeleton__right {
      flex: 1;
      width: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 20px;
    }

    .el-skeleton__image {
      width: 80px;
      height: 62px;
    }

    .el-skeleton__text {
      &:nth-child(1) {
        width: 80%;
      }

      &:nth-child(2) {
        width: 90%;
      }
    }
  }
}
</style>
